import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

import { colors } from "../dark-hero/colors";
import { PageContainer } from "../dark-hero/PageContainer";
import { TOO_GOOD_TO_BE_TRUE } from "./honest-buildContent";
import { BODY_SX, LABEL_SX, REVEAL, SECTION_SX, TITLE_SX } from "./sectionStyles";

const MotionBox = motion(Box);

const factsBoxSx = {
  mt: { xs: "2.5rem", md: "3.5rem" },
  maxWidth: "40rem",
  p: { xs: "20px 18px", md: "28px 24px" },
  border: `1px solid ${colors.border.default}`,
  borderRadius: "18px",
  background: "linear-gradient(180deg, rgba(255,255,255,0.025), transparent)",
};

const factsTitleSx = {
  fontFamily: "'Inter', system-ui, sans-serif",
  fontSize: "0.85rem",
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: colors.primary.main,
  mb: 1.5,
};

const listSx = {
  m: 0,
  pl: "1.15rem",
  display: "flex",
  flexDirection: "column",
  gap: 1,
};

const itemSx = {
  fontSize: "0.95rem",
  lineHeight: 1.65,
  color: colors.text.secondary,
};

export default function TooGoodToBeTrue() {
  return (
    <Box component="section" sx={SECTION_SX}>
      <PageContainer sx={{ maxWidth: "75rem" }}>
        <MotionBox {...REVEAL} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}>
          <Typography component="div" sx={LABEL_SX}>
            {TOO_GOOD_TO_BE_TRUE.eyebrow}
          </Typography>
          <Typography component="h2" sx={TITLE_SX}>
            Sounds too good to be <span>{TOO_GOOD_TO_BE_TRUE.titleAccent}?</span>
          </Typography>
          <Typography sx={{ ...BODY_SX, mt: 2 }}>{TOO_GOOD_TO_BE_TRUE.body}</Typography>
        </MotionBox>
        <MotionBox
          {...REVEAL}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          sx={factsBoxSx}
        >
          <Typography sx={factsTitleSx}>{TOO_GOOD_TO_BE_TRUE.teamTitle}</Typography>
          <Box component="ul" sx={listSx}>
            {TOO_GOOD_TO_BE_TRUE.teamFacts.map((fact) => (
              <Typography key={fact} component="li" sx={itemSx}>
                {fact}
              </Typography>
            ))}
          </Box>
        </MotionBox>
        <MotionBox
          {...REVEAL}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          sx={{ ...factsBoxSx, mt: { xs: "1.25rem", md: "1.5rem" } }}
        >
          <Typography sx={factsTitleSx}>{TOO_GOOD_TO_BE_TRUE.steamFactsTitle}</Typography>
          <Box component="ul" sx={listSx}>
            {TOO_GOOD_TO_BE_TRUE.steamFacts.map((fact) => (
              <Typography key={fact} component="li" sx={itemSx}>
                {fact}
              </Typography>
            ))}
          </Box>
        </MotionBox>
      </PageContainer>
    </Box>
  );
}
